// src/components/Hero.tsx
import React from "react";
import { Box, Typography, Button, Container, Stack } from "@mui/material";
import { motion } from "framer-motion";

export const Hero = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(45deg, #0A2540 30%, #635BFF 90%)",
        color: "white",
        pt: 15,
        pb: 10,
        clipPath: "polygon(0 0, 100% 0, 100% 90%, 0% 100%)",
      }}
    >
      <Container maxWidth="lg">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Typography variant="overline" sx={{ letterSpacing: 3, color: "#00D4FF" }}>
            Netcomserve Global Services Limited
          </Typography>
          <Typography variant="h2" sx={{ fontWeight: 800, mt: 2, mb: 3 }}>
            Vibrant, Dynamic & <br /> Innovative IT Solutions
          </Typography>
          <Typography variant="h5" sx={{ mb: 4, opacity: 0.9, maxWidth: "700px" }}>
            A one-stop provider for mundane and critical IT issues—focused on performance, integrity, and teamwork.
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              size="large"
              sx={{ bgcolor: "#00D4FF", color: "#0A2540", "&:hover": { bgcolor: "#fff" } }}
            >
              Explore Solutions
            </Button>
            <Button variant="outlined" size="large" sx={{ color: "white", borderColor: "white" }}>
              Contact Support
            </Button>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
};
